import AbstractController from './AbstractController';
import statusChecker from '@/components/StatusChecker';

export default class Index extends AbstractController {
    constructor() {
        super();

        this.checkOrderStatusRequest();
        this.legacy();
    }

    checkOrderStatusRequest() {
        if (document.location.hash.length < 2) {
            return;
        }

        let orderId = document.location.hash.slice(1);

        if (!/^[\d]{6,7}$/.test(orderId)) {
            return;
        }

        statusChecker.showStatus(orderId);
    }

    legacy() {
        $('.features__pay').on('click', function (e) {
            e.preventDefault();
            $.fancybox($('.pay-popup'), {
                padding: 0,
                fitToView: false
            });
        });
    }
}